import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SvgRegistry {
  private readonly _http = inject(HttpClient);
  private readonly _cache = new Map<string, Observable<string>>();
  private readonly _registry = new Map<string, string>();

  add(name: string, path: string): void {
    this._registry.set(name, path);
  }

  get(name: string): Observable<string> {
    if (!this._registry.has(name)) {
      console.warn(`[SvgRegistry] SVG "${name}" is not registered.`);
      return of('');
    }

    if (this._cache.has(name)) {
      return this._cache.get(name)!;
    }

    const path = this._registry.get(name)!;
    const svg$ = this._http.get(path, { responseType: 'text' }).pipe(
      map((content) => this._sanitizeSvg(content)),
      catchError((error) => {
        console.error(
          `[SvgRegistry] Failed to fetch SVG "${name}" from "${path}":`,
          error,
        );
        return of('');
      }),
      shareReplay(1),
    );

    this._cache.set(name, svg$);
    return svg$;
  }

  private _sanitizeSvg(content: string): string {
    return content.trim();
  }
}
